import { render, staticRenderFns } from "./GreenApp.vue?vue&type=template&id=7021520a&scoped=true&"
import script from "./GreenApp.vue?vue&type=script&lang=js&"
export * from "./GreenApp.vue?vue&type=script&lang=js&"
import style0 from "./GreenApp.vue?vue&type=style&index=0&id=7021520a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7021520a",
  null
  
)

export default component.exports